import { 
    createSlice, 
    createAsyncThunk,  
    createEntityAdapter,
    createSelector,  
} from '@reduxjs/toolkit'
import { ChannelSyncModel } from '../models/ChannelSyncModel';


const channelSyncAdapter = createEntityAdapter()

export const channelSyncApi = {
    _getToken: (thunkAPI) => {
        return thunkAPI.getState().identityReducer.token.signature;
    },
    fetchAll: createAsyncThunk(
        'channelSync/fetchAll', 
        async ({channelId}, thunkAPI) => {
            try {
                const token = channelSyncApi._getToken(thunkAPI)
                const channelSyncModel = new ChannelSyncModel(token)

                return channelSyncModel.getChannelSyncStatusById(channelId)
            } catch (apiError) {
                console.error(apiError)
                return thunkAPI.rejectWithValue(apiError.toJson());
            }
        }
    ),
    fetchById: createAsyncThunk(
        'channelSync/fetchById', 
        async ({id}, thunkAPI) => {
            const token = channelSyncApi._getToken(thunkAPI)
            const channelSyncModel = new ChannelSyncModel(token)

            try {
                return await channelSyncModel.getChannelSyncStatusById(id)
            } catch (apiError) {
                return thunkAPI.rejectWithValue(apiError.toJson());
            }
        }
    ),
    create: createAsyncThunk(
        'channelSync/create', 
        async ({channelId, channelProductIds, channelProductStatusList, channelProductVariantIds, channelProductVariantStatusList}, thunkAPI) => {
            try {
                const token = channelSyncApi._getToken(thunkAPI)
                const channelSyncModel = new ChannelSyncModel(token)

                return channelSyncModel.enqueueChannelSyncRequest(channelId, channelProductIds, channelProductStatusList, channelProductVariantIds, channelProductVariantStatusList)
            } catch (apiError) {
                return thunkAPI.rejectWithValue(apiError.toJson());
            }
        }
    ),
}

const channelSyncSlice = createSlice({
    name: "channelSync",
    initialState: channelSyncAdapter.getInitialState({
        status: 'idle',
        error: null,
        syncStatus: null,
    }),
    reducers: {},
    extraReducers: {
        [channelSyncApi.fetchById.fulfilled]: (state, action) => {
            state.status = 'channelSync/fetchById/succeeded'
            state.error = null
            channelSyncAdapter.upsertOne(state, action.payload[0]);
        },
        [channelSyncApi.fetchById.rejected]: (state, action) => {
            state.status = 'channelSync/fetchById/rejected'
            state.error = action.payload
        },

        [channelSyncApi.fetchAll.fulfilled]: (state, action) => {
            state.status = 'channelSync/fetchAll/succeeded'
            state.error = null
            console.log(action.payload)
            state.syncStatus = action.payload[0]
        },
        [channelSyncApi.fetchAll.rejected]: (state, action) => {
            state.status = 'channelSync/fetchAll/rejected'
            state.error = action.payload
        },

        [channelSyncApi.create.fulfilled]: (state, action) => {
            state.status = 'channelSync/create/succeeded'
            state.error = null
            state.syncStatus = action.payload
        },
        [channelSyncApi.create.pending]: (state, action) => {
            state.status = 'channelSync/create/pending'
        },
        [channelSyncApi.create.rejected]: (state, action) => {
            state.status = 'channelSync/create/rejected'
            state.error = action.payload
        },
        
    }
});


export const {
    selectAll: selectAllChannelSyncs,
    selectById: selectChannelSyncById,
} = channelSyncAdapter.getSelectors((state) => state.channelSyncReducer)

// export const { } = channelSyncSlice.actions;

export default channelSyncSlice.reducer;
